import { render, staticRenderFns } from "./DialogDeleteReport.vue?vue&type=template&id=1f78d6d7&"
import script from "./DialogDeleteReport.vue?vue&type=script&lang=js&"
export * from "./DialogDeleteReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f78d6d7')) {
      api.createRecord('1f78d6d7', component.options)
    } else {
      api.reload('1f78d6d7', component.options)
    }
    module.hot.accept("./DialogDeleteReport.vue?vue&type=template&id=1f78d6d7&", function () {
      api.rerender('1f78d6d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogDeleteReport.vue"
export default component.exports